export default {
	state: {
		cpf: {}
	},
	getters: {
		"cpf": state => state.cpf
	},
	mutations: {
		setCpf(state, payload) {
			state.cpf = payload
		}
	},
	actions: {
		atualizarEstadoCpf({ commit }, payload) {
			commit('setCpf', payload)
		}
	}
};